import { useQuery } from "@tanstack/react-query";
import type { AuditLogListParams } from "../../../finance-api/reports/audit-logs";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useAuditLog(clubId: string | null, params: AuditLogListParams = {}) {
	return useQuery({
		queryKey: queryKeys.clubPortal.auditLogs(clubId ?? "", params),
		queryFn: () => financeApi.auditLogs.list(clubId!, params),
		enabled: !!clubId,
		staleTime: 60_000,
	});
}
